/**
 * Which COMMS resolution cards are currently undone (`comms-undo-entry`). The feed is append-only
 * (`decisions/0040`), so an undone card is never edited: an `"undo"` feed line names the cards its
 * walked undo unit bridged, a later `"redo"` naming them lifts the strike. Folded in feed order.
 */
import type { FeedEntry } from "@lancer-vtt/shared";

export function undoneResolutionIds(feed: readonly FeedEntry[]): Set<string> {
  const undone = new Set<string>();
  for (const entry of feed) {
    if (entry.kind !== "system" || entry.undoneResolutionIds === undefined) continue;
    for (const id of entry.undoneResolutionIds) {
      if (entry.event === "undo") undone.add(id);
      else if (entry.event === "redo") undone.delete(id);
    }
  }
  return undone;
}
